export function confirmation(titre: string, pos = 'top-end', icone = 'success',
                             showConfBut = false, timeToWait = 1500): any  {
  return { position: pos, icon: icone, text: titre, showConfirmButton: showConfBut, timer: timeToWait};
}
